import { deprecated, createAsyncAction, createAction } from 'typesafe-actions';
import { AxiosError } from 'axios';
import {
  GetSearchType,
  GetSearchParamType,
  GetRelatedWordParamType,
  GetRelatedWordType,
  GetPopularKeywordType,
  GetPopularKeywordParamType,
  GetWikiType,
  GetWikiParamType,
  GetSpellCheckerParamType,
  GetSpellCheckerType,
  GetSearchImageParamType,
  GetSearchImageType,
  GetSearchAttachParamType,
  GetSearchAttachResponseType,
} from '../../lib/tabResult/type';
import { tabResultState } from './types';

// const { createAction } = deprecated;

export const GET_SEARCH = 'tabResult/GET_SEARCH' as const;
export const GET_SEARCH_SUCCESS = 'tabResult/GET_SEARCH_SUCCESS' as const;
export const GET_SEARCH_ERROR = 'tabResult/GET_SEARCH_ERROR' as const;

export const GET_SEARCH_IMAGE = 'tabResult/GET_SEARCH_IMAGE' as const;
export const GET_SEARCH_IMAGE_SUCCESS = 'tabResult/GET_SEARCH_IMAGE_SUCCESS' as const;
export const GET_SEARCH_IMAGE_ERROR = 'tabResult/GET_SEARCH_IMAGE_ERROR' as const;

export const GET_RELATED_WORD = 'tabResult/GET_RELATED_WORD' as const;
export const GET_RELATED_WORD_SUCCESS = 'tabResult/GET_RELATED_WORD_SUCCESS' as const;
export const GET_RELATED_WORD_ERROR = 'tabResult/GET_RELATED_WORD_ERROR' as const;

export const GET_POPULAR_KEYWORD = 'tabResult/GET_POPULAR_KEYWORD' as const;
export const GET_POPULAR_KEYWORD_SUCCESS = 'tabResult/GET_POPULAR_KEYWORD_SUCCESS' as const;
export const GET_POPULAR_KEYWORD_ERROR = 'tabResult/GET_POPULAR_KEYWORD_ERROR' as const;

export const GET_WIKI = 'tabResult/GET_WIKI' as const;
export const GET_WIKI_SUCCESS = 'tabResult/GET_WIKI_SUCCESS' as const;
export const GET_WIKI_ERROR = 'tabResult/GET_WIKI_ERROR' as const;

export const SET_IS_MORE_INFO_RESULT = 'tabResult/SET_IS_MORE_INFO_RESULT' as const;
export const SET_IS_MORE_INFO_IMAGE = 'tabResult/SET_IS_MORE_INFO_IMAGE' as const;
export const SET_IS_MORE_INFO_ATTACHMENT = 'tabResult/SET_IS_MORE_INFO_ATTACHMENT' as const;

export const GET_SPELL_CHECKER = 'tabResult/GET_SPELL_CHECKER' as const;
export const GET_SPELL_CHECKER_SUCCESS = 'tabResult/GET_SPELL_CHECKER_SUCCESS' as const;
export const GET_SPELL_CHECKER_ERROR = 'tabResult/GET_SPELL_CHECKER_ERROR' as const;

export const GET_SEARCH_ATTACH = 'tabResult/GET_SEARCH_ATTACH' as const;
export const GET_SEARCH_ATTACH_SUCCESS = 'tabResult/GET_SEARCH_ATTACH_SUCCESS' as const;
export const GET_SEARCH_ATTACH_ERROR = 'tabResult/GET_SEARCH_ATTACH_ERROR' as const;

export const SET_SEARCH_DATA_NULL = 'tabResult/SET_SEARCH_DATA_NULL' as const;

export const getSearchAsync = createAsyncAction(
  GET_SEARCH,
  GET_SEARCH_SUCCESS,
  GET_SEARCH_ERROR
)<GetSearchParamType, GetSearchType, AxiosError>();

export const getSearchImageAsync = createAsyncAction(
  GET_SEARCH_IMAGE,
  GET_SEARCH_IMAGE_SUCCESS,
  GET_SEARCH_IMAGE_ERROR
)<GetSearchImageParamType, GetSearchImageType, AxiosError>();

export const getSearchAttachmentAsync = createAsyncAction(
  GET_SEARCH_ATTACH,
  GET_SEARCH_ATTACH_SUCCESS,
  GET_SEARCH_ATTACH_ERROR
)<GetSearchAttachParamType, GetSearchAttachResponseType, AxiosError>();

export const getRelatedWordAsync = createAsyncAction(
  GET_RELATED_WORD,
  GET_RELATED_WORD_SUCCESS,
  GET_RELATED_WORD_ERROR
)<GetRelatedWordParamType, GetRelatedWordType, AxiosError>();

export const getPopularKeywordAsync = createAsyncAction(
  GET_POPULAR_KEYWORD,
  GET_POPULAR_KEYWORD_SUCCESS,
  GET_POPULAR_KEYWORD_ERROR
)<GetPopularKeywordParamType, GetPopularKeywordType, AxiosError>();

export const getWikiAsync = createAsyncAction(
  GET_WIKI,
  GET_WIKI_SUCCESS,
  GET_WIKI_ERROR
)<GetWikiParamType, GetWikiType, AxiosError>();

export const getSpellCheckerAsync = createAsyncAction(
  GET_SPELL_CHECKER,
  GET_SPELL_CHECKER_SUCCESS,
  GET_SPELL_CHECKER_ERROR
)<GetSpellCheckerParamType, GetSpellCheckerType, AxiosError>();

export const setIsMoreInfoResult = createAction(
  SET_IS_MORE_INFO_RESULT,
  (isMoreInfoResult: tabResultState['isMoreInfoResult']) => isMoreInfoResult
)<tabResultState['isMoreInfoResult']>();

export const setIsMoreInfoAttachment = createAction(
  SET_IS_MORE_INFO_ATTACHMENT,
  (isMoreInfoAttach: tabResultState['isMoreInfoAttach']) => isMoreInfoAttach
)<tabResultState['isMoreInfoAttach']>();

export const setIsMoreInfoImage = createAction(
  SET_IS_MORE_INFO_IMAGE,
  (isMoreInfoImage: tabResultState['isMoreInfoImage']) => isMoreInfoImage
)<tabResultState['isMoreInfoImage']>();

export const setSearchDataNull = createAction(SET_SEARCH_DATA_NULL)();
